<template>
    <div class="animated fadeIn custom-cases bgV2">
        <div class="d-flex headerOrderDetail">
            <div class="orderNumber d-flex justify-content-between align-items-end pr-4 w-100">
                <div class="mt-20 pl-20">
                    <h1 class="mb-1">{{Item.job_number}}</h1>
                </div>
                <h4 class="c-orange mb-0" v-if="Item.id">{{Item.status}}</h4>
            </div>
        </div>
        <b-row>
            <b-col md="12">
                <gofix-tab
                    class="mt-3 contractPropertyTab"
                    :data="tabData">
                    <template slot="gofixTab:right">
                        <gofix-button class="mr-3" label="Permit To Work Report" @click="reportJob"></gofix-button>
                        <gofix-button
                            v-if="isShowNextAction"
                            :disabled="!this.$checkRole(this.$accessModule.permit_to_work, 'update')"
                            class="mr-3" 
                            label="NEXT ACTION"
                            @click="changeStatus" outline>
                        </gofix-button>
                        <gofix-button
                            :disabled="!this.$checkRole(this.$accessModule.permit_to_work, 'update') || isDisabledSave"
                            :loading="loadingSave"
                            @click="updateData"
                            label="SAVE">
                        </gofix-button>
                    </template>
                    <template slot="gofixTab:basic-info">
                        <detail-info @reloadItem="reloadItemDetail" ref="basic-info" :job="job_active" :checklistEntries="checklistEntriesActive" :onClickShowGeo="handleShowGeoFencing"></detail-info>
                        <b-row>
                            <b-col md="12" class="mb-13 text-center">
                                <h3>Day</h3>
                                <b-list-group horizontal class="justify-content-center">
                                    <b-list-group-item 
                                        @click="activeJob(item)" 
                                        v-for="(item, index) in jobsRelated" 
                                        :key="index" 
                                        :class="[{'bg-gray-e9e': !item}, {'cursor-pointer': item && item.id !== null}, {'active': item && item.id && (item.id == job_active.id)}]"
                                        :style="[item && item.id === null ? {'background': '#20a8d8', 'borderColor': 'rgba(0, 0, 0, 0.125)', 'color': 'white'} : {}]"
                                    >
                                        <span>{{ index + 1 }}</span>
                                    </b-list-group-item>
                                </b-list-group>
                            </b-col>
                        </b-row>
                        <!-- Content Checklist -->
                        <gofix-card :title="`${textShow.name_of_stage_1b} ${dayText}`" :class="['position-relative mb-13 pt-16 px-24 pb-19', {'run-loading': loadingCheckListEntry }]" classHeader="mb-13 pd-0" classContent="pd-0 mb-0">
                            <p>{{ textShow.desc_of_stage_1b }}</p>
                            
                            <div class="position-absolute" style="right: 50px; top: 15px; font-size: 16px;"><b>{{ job_active && job_active.status ? `Status: ${job_active.status}` : '' }}</b></div>
                            <b-row no-gutters>
                                <template v-for="(item, index) in tableItems">
                                    <b-col md="12" class="mb-13" :key="index" v-if="item.children.length == 0">
                                        <checklist-entries :job="Item" :section="item.name" @updateCheckListEntries="updateCheckListEntries" @selectChecklistEntry="selectChecklistEntry" @reloadChecklist="reloadChecklist" @inputType="isTyping = true" :item="item" typeJob="PTW"></checklist-entries>
                                    </b-col>
                                    <template v-else>
                                        <template v-for="(item1) in item.children">
                                        <b-col md="12" class="mb-13" :key="item1.id">
                                            <checklist-entries :job="Item" :section="item.name + ' >> ' + item1.name" @updateCheckListEntries="updateCheckListEntries" @selectChecklistEntry="selectChecklistEntry" @reloadChecklist="reloadChecklist" @inputType="isTyping = true" :item="item1" typeJob="PTW"></checklist-entries>
                                        </b-col>
                                        </template>
                                    </template>
                                </template>
                            </b-row>
                            
                            <signature :signatures="signatureByStatus.submitted_signatures" :job="Item" typeComment="comment_cs" @reloadItem="reloadItemDetail"></signature>

                            <gofix-card title="Photos" classHeader="mb-2" classContent="position-relative pr-83">
                                <b-row align-v="center" class="mt-3">
                                    <b-col md="12">
                                        <div>
                                            <div v-if="info.photos && info.photos.length" class="photosThumb photosThumb-safety mt-0 mb-0">
                                                <viewer-image :images="info.photos">
                                                    <template slot="gofixViewer:list_image" ref="viewerFinding" slot-scope="{images}">
                                                        <ul class="list-thumb mb-2">
                                                            <template v-for="(item, key) in info.photos">
                                                                <li :key="key">
                                                                    <img v-auth-image="item.url.medium" alt  src="img/loading.gif"/>
                                                                    <span class="delete" @click.stop="deleteFile(item)" v-if="$checkRole($accessModule.permit_to_work, 'update')">
                                                                        <img src="img/close.png" alt />
                                                                    </span>
                                                                </li>
                                                            </template>
                                                        </ul>
                                                    </template>
                                                </viewer-image>
                                            </div>
                                            <div class="upload-btn-wrapper ml-0 mt-0 d-block">
                                                <b-form-file id="fileInputMulti" v-model="attachment.files" :plain="true" :multiple="true"></b-form-file>
                                                <gofix-button class="icon-svg icon-svg-left mb-2" label="Upload" outline v-if="$checkRole($accessModule.permit_to_work, 'update')">
                                                    <template slot="gofix:button:beforeLabel">
                                                        <span class="icon mr-2">
                                                            <svg width="23" height="19" viewBox="0 0 23 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M11.6537 8.20604C11.6355 8.1827 11.6121 8.16382 11.5855 8.15083C11.5588 8.13785 11.5296 8.1311 11.4999 8.1311C11.4703 8.1311 11.441 8.13785 11.4144 8.15083C11.3877 8.16382 11.3644 8.1827 11.3461 8.20604L8.61175 11.6655C8.58921 11.6943 8.57522 11.7288 8.57139 11.7652C8.56755 11.8016 8.57403 11.8383 8.59007 11.8711C8.60612 11.904 8.63108 11.9317 8.66212 11.951C8.69315 11.9703 8.72899 11.9805 8.76556 11.9805H10.5698V17.8984C10.5698 18.0058 10.6576 18.0937 10.7651 18.0937H12.2299C12.3373 18.0937 12.4252 18.0058 12.4252 17.8984V11.9829H14.2343C14.3979 11.9829 14.4882 11.7949 14.3881 11.668L11.6537 8.20604Z" fill="#F05600" />
                                                                <path d="M18.8096 5.95264C17.6914 3.00342 14.8423 0.90625 11.5049 0.90625C8.16748 0.90625 5.31836 3.00098 4.2002 5.9502C2.10791 6.49951 0.5625 8.40625 0.5625 10.6719C0.5625 13.3696 2.74756 15.5547 5.44287 15.5547H6.42188C6.5293 15.5547 6.61719 15.4668 6.61719 15.3594V13.8945C6.61719 13.7871 6.5293 13.6992 6.42188 13.6992H5.44287C4.62012 13.6992 3.84619 13.3721 3.27002 12.7788C2.69629 12.188 2.39111 11.3921 2.41797 10.5669C2.43994 9.92236 2.65967 9.31689 3.05762 8.80664C3.46533 8.28662 4.03662 7.9082 4.67139 7.73975L5.59668 7.49805L5.93604 6.60449C6.146 6.04785 6.43896 5.52783 6.80762 5.05664C7.17156 4.58962 7.60267 4.17908 8.08691 3.83838C9.09033 3.13281 10.272 2.75928 11.5049 2.75928C12.7378 2.75928 13.9194 3.13281 14.9229 3.83838C15.4087 4.18018 15.8384 4.59033 16.2021 5.05664C16.5708 5.52783 16.8638 6.05029 17.0737 6.60449L17.4106 7.49561L18.3335 7.73975C19.6567 8.09619 20.582 9.2998 20.582 10.6719C20.582 11.48 20.2671 12.2417 19.6958 12.813C19.4156 13.0948 19.0823 13.3182 18.7152 13.4703C18.3481 13.6225 17.9545 13.7003 17.5571 13.6992H16.5781C16.4707 13.6992 16.3828 13.7871 16.3828 13.8945V15.3594C16.3828 15.4668 16.4707 15.5547 16.5781 15.5547H17.5571C20.2524 15.5547 22.4375 13.3696 22.4375 10.6719C22.4375 8.40869 20.897 6.5044 18.8096 5.95264Z" fill="#F05600" />
                                                            </svg>
                                                        </span>
                                                    </template>
                                                </gofix-button>
                                            </div>
                                        </div>
                                    </b-col>
                                </b-row>
                            </gofix-card>

                            <signature :title="`${textShow.name_of_stage_2} ${dayText}`" :desc="textShow.desc_of_stage_2" :signatures="signatureByStatus.pending_approval_signatures" :job="job_active" typeComment="comment_sa" @reloadItem="reloadItemDetail" :isShowChecklistChild="job_active && job_active.id && job_active.type && job_active.type == 'WAH' ? true : false" @loadChecklistEntriesOfJobChild="updateCheckListEntriesActive" @changeChecklistEntry="changeChecklistEntry" :onClickShowGeo="handleShowGeoFencing"></signature>

                            <signature :title="`Stage 3: Permit Authorization ${dayText}`" desc="To be filled up by Appointed Project Manager(PM) / Manager-in-Charge(WM)*" :signatures="signatureByStatus.approved_signatures" :job="job_active" typeComment="comment_pm" @reloadItem="reloadItemDetail" :onClickShowGeo="handleShowGeoFencing"></signature>

                        </gofix-card>
                    </template>
                    <!-- <template slot="gofixTab:permit_to_work">
                        <PermitToWorkItems @reloadItem="getItem" class="mb-3"></PermitToWorkItems>
                        <signature :job="Item"></signature>
                    </template>
                    <template slot="gofixTab:signature">
                        <signature :job="Item"></signature>
                    </template>
                    <template slot="gofixTab:activity-log">
                        <activities ref="activities" activityType="Job Safety" :activityId="$route.params.id"></activities>
                    </template> -->
                </gofix-tab>
            </b-col>
        </b-row>
        <ModalRemarkFollowUp v-model="modals.remark.open" :item="modals.remark.checklistEntry" :job="Item" typeJob="PTW" @reloadChecklist="reloadChecklist"/>
        <b-modal
            id="modal-Remove"
            :title="modals.geo.title"
            :no-close-on-backdrop="true"
            dialog-class="modal-confirm-update"
            hide-footer
            :centered="true"
            v-model="modals.geo.open">
            <div class="">
                <template v-if="modals.geo.items.length > 0">
                    <ul class="list-group" v-for="item in modals.geo.items" :key="item.id">
                        <li class="list-group-item border-0 text-left">
                            <gofix-text-field label="Longitude:" classLabel="width-70 mb-2" oneline>{{ item.longitude }}</gofix-text-field>
                            <gofix-text-field label="Latitude:" classLabel="width-70 mb-2" oneline>{{ item.latitude }}</gofix-text-field>
                            <gofix-text-field label="Location:" classLabel="width-70" oneline>{{ item.remark }}</gofix-text-field>
                        </li>
                    </ul>
                </template>
                <ul class="list-group" v-else>
                    <li class="list-group-item border-0 text-left">
                        <gofix-text-field label="Longitude:" classLabel="width-70 mb-2" oneline>--</gofix-text-field>
                        <gofix-text-field label="Latitude:" classLabel="width-70 mb-2" oneline>--</gofix-text-field>
                        <gofix-text-field label="Location:" classLabel="width-70" oneline>--</gofix-text-field>
                    </li>
                </ul>
            </div>
        </b-modal>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex';
    import moment from 'moment';
    const Activities = () => import("../activities")
    const DetailInfo = () => import("./detail-info")
    const checklistEntries = () => import("../detail-checklist")
    const PermitToWorkItems = () => import("./detail-related-items")
    const Signature = () => import("./detail-signature")
    const ModalRemarkFollowUp = () => import("../modal_remark_follow_up")
    const ViewerImage = () => import('@/views/plugins/ViewerImage.vue')
    export default {
        name: 'permit-to-work-detail',
        components: {
            DetailInfo,
            checklistEntries,
            Activities,
            PermitToWorkItems,
            Signature,
            ModalRemarkFollowUp,
            ViewerImage
        },
        data() {
            return {
                tabData:[
                    {
                        key: "basic-info",
                        title: "Basic Info",
                        active: true
                    },         
                ],
                tableItems: [],
                loadingCheckListEntry: false,
                modals: {
                    status: {
                        open: false,
                        loading: false
                    },
                    approval_log: {
                        open: false,
                        loading: false
                    },
                    remark: {
                        open: false,
                        checklistEntry: null
                    },
                    geo: {
                        open: false,
                        title: "Geo Fencing",
                        items: []
                    },
                },
                isModalShow: false,
                isTyping: false,
                isSave: false,
                checkListEntryUpdate: [],
                loadingSave: false,
                timer_save: null,
                timer_report: null,
                job_active: {
                    id: null
                },
                info: {
                    photos: [],
                },
                attachment: {
                    items: [],
                    files: [],
                },
                text_shows: {
                    wah: {
                        name_of_stage_1b: "Stage 1B: Application Details",
                        desc_of_stage_1b: "I declare the information provided is accurate and control measures have been implemented.",
                        name_of_stage_2: "Stage 2: Permit Evaluation By WAH Assessor",
                        desc_of_stage_2: "Permit Applicant and WAH Assessor had jointly inspected and confirmed that the reasonable and practicable risk control measures are implemented satisfactory otherwise corrective actions and re-apply.",
                    },
                    lifting_operations: {
                        name_of_stage_1b: "Stage 1B: Declaration by Permit Applicant",
                        desc_of_stage_1b: "I undertake to take all necessary measures to render the work to be carried out safely and ensure compliance with the WSH (Operation of Cranes) Reg. for lifting operation.",
                        name_of_stage_2: "Stage 2: Joint Inspection by Applicant and Appointed Lifting Supervisor",
                        desc_of_stage_2: "Permit Applicant and Lifting Supervisor had jointly inspected that the reasonable and practicable risk control measures have been implemented satisfactory. The permit shall be valid consecutively if daily inspection is done and signed.",
                    },
                    hot_works: {
                        name_of_stage_1b: "Stage 1B: Declaration by Applicant",
                        desc_of_stage_1b: "I undertake to take all necessary measures to render the work to be carried out safely and ensure compliance with legislative requirements, SS510 etc prior to the commencement and during hot work.",
                        name_of_stage_2: "Stage 2: Joint Inspection by Applicant and Appointed Safety Assessor",
                        desc_of_stage_2: "Permit Applicant and Safety Assessor had jointly inspected that the reasonable and practicable risk control measures have been implemented satisfactory. The permit shall be valid consecutively if daily inspection is done and signed.",
                    }
                },
                checklistEntriesActive: [],
                isNotSave: false
            }
        },
        computed: {
            ...mapGetters({
                ApprovalLogs: 'LMUApprovalRequestController/approvalLogs',
                User : 'AuthController/user',
                Item: 'SafetyAppController/safetyJob',
            }),
            isDisabledSave() {
                return this.Item && (this.Item.related_id == null && this.Item.status != 'New');
            },
            jobsRelated() {
                if(this.Item && this.Item.id == this.$route.params.id) {
                    let dayIndexExpiry = null;
                    if(this.Item && this.Item.expiry_date) {
                        dayIndexExpiry = new Date(this.Item.expiry_date).getDay();
                    }

                    let dayIndexPlanned = null;
                    if(this.Item && this.Item.planned_date) {
                        dayIndexPlanned = new Date(this.Item.planned_date).getDay();
                    }
                    
                    let related = Array.from({ length: 7 }, (item, index) => {
                        if(dayIndexExpiry !== null && dayIndexPlanned !== null && (dayIndexPlanned - 1) <= index &&  index < dayIndexExpiry) {
                            return { id: null }
                        }
                        return null;
                    });

                    if(this.Item && this.Item.related && this.Item.related.length) {
                        for (let index = 0; index < this.Item.related.length; index++) {
                            const job = this.Item.related[index];
                            const dayIndex = new Date(job.planned_date).getDay();

                            if(dayIndex == 0) continue;
                            related[dayIndex - 1] = job;
                            if(this.job_active.id == null && new Date(job.planned_date).toDateString() === new Date().toDateString()) {
                                job.type = this.Item.type
                                this.job_active = job;
                            }
                        }

                        if(!this.job_active || !this.job_active.id) {
                            this.job_active = this.Item.related[0];
                        }
                    }
                    return related;
                }
                return [];
            },
            textShow() {
                if(this.Item) {
                    let type = "wah";
                    if(this.Item.job_type) {
                        type = this.Item.job_type.toLowerCase().replace(/\s/g, '_');
                    }
                    if(this.text_shows && this.text_shows[type]) return this.text_shows[type];
                }
                return {
                    name_of_stage_1b: "",
                    desc_of_stage_1b: "",
                    name_of_stage_2 : "",
                    desc_of_stage_2 : ""
                };
            },
            dayText() {
                if(this.job_active && this.job_active.planned_date) {
                    return `(Day ${new Date(this.job_active.planned_date).getDay()})`;
                }
                return '';
            },
            signatureByStatus() {
                let signatures = {
                    submitted_signatures: [{
                        created_at: this.Item && this.Item.submitted_at ? this.Item.submitted_at : null,
                        user: this.Item && this.Item.submitted_by ? this.Item.submitted_by : null
                    }],
                    pending_approval_signatures: [{
                        created_at: this.job_active && this.job_active.pending_approval_at ? this.job_active.pending_approval_at : null,
                        user: this.job_active && this.job_active.pending_approval_by ? this.job_active.pending_approval_by : null
                    }],
                    approved_signatures: [{
                        created_at: this.job_active && this.job_active.approved_at ? this.job_active.approved_at : null,
                        user: this.job_active && this.job_active.approved_by ? this.job_active.approved_by : null
                    }]
                }

                if(this.Item && this.Item.submitted_signatures && this.Item.submitted_signatures.length) {
                    signatures.submitted_signatures = this.Item.submitted_signatures;
                }

                if(this.job_active && this.job_active.pending_approval_signatures && this.job_active.pending_approval_signatures.length) {
                    signatures.pending_approval_signatures = this.job_active.pending_approval_signatures;
                }
                
                if(this.job_active && this.job_active.approved_signatures && this.job_active.approved_signatures.length) {
                    signatures.approved_signatures = this.job_active.approved_signatures;
                }

                return signatures;
            },
            isShowNextAction() {
                if(this.Item && this.Item.status  && ['Rejected', 'Expired', 'Closed'].includes(this.Item.status)) {
                    return false;
                }

                if(this.Item && this.Item.status && !['Approved'].includes(this.Item.status)) {
                    let today = moment().format("YYYY-MM-DD");
                    if(this.Item && this.Item.expiry_date && moment(today).isAfter(moment(this.Item.expiry_date).format("YYYY-MM-DD"))) {
                        return false;
                    }
                }
                
                return true;
            }
        },
        watch: {
            Item: function(val) {
                if(val && val.id == this.$route.params.id) {
                    this.getCheckListGroupData()
                    this.info = JSON.parse(JSON.stringify(val));
                    this.info.photos = this.info.photos ? this.info.photos : [];
                    this.job_active = {
                        id: null
                    }
                    if(val.related && !val.related.length) {
                        if(this.job_active.id == null) this.job_active = this.info;
                    }
                    if(val.status == 'Approved') {
                        let today = moment().format("YYYY-MM-DD");
                        if(this.Item && this.Item.expiry_date && moment(today).isAfter(moment(this.Item.expiry_date).format("YYYY-MM-DD"))) {
                            this.job_active = this.info;
                        }
                    }
                }
            },
            isTyping: function(val) {
                if(val === false && this.isSave === true) {
                    this.updateData();
                }
            },
            "attachment.files": async function(val, old) {
                if (val) {
                    if(val.length > 4 || ((val.length + this.attachment.items.length) > 4)) {
                        return this.$alertNotification("Max photos: 4", "danger");
                    }

                    val.forEach(async (file) => {
                        if (
                            file.type != "image/jpeg" &&
                            file.type != "image/png" &&
                            file.type != "image/gif"
                        ) {
                            this.$alertNotification("File format is incorrect. Please select a .jpeg, .jpg, .png, .gif file!", "warning");
                            return;
                        }
                        file.moment = moment().valueOf();
                        let data = {
                            moment: moment().valueOf(),
                            url: {
                                original: URL.createObjectURL(file),
                                medium: URL.createObjectURL(file),
                                thumb: URL.createObjectURL(file),
                            }
                        };
                        await this.attachment.items.push(file);
                        // this.info.photos.push(data);
                    });

                    await this.saveWithPhotos();
                }
                
            },
            "job_active.id": function(val, old) {
                if(val && (!old || old && val != old)) {
                    this.getJobActive(val);
                }
            }
        }, 
        mounted() {
            const _this = this;
            this.$root.$on('bv::modal::show', (bvEvent, modalId) => {
                if(modalId == 'msgConfirm') _this.isModalShow = true;
            })
            this.$root.$on('bv::modal::hide', (bvEvent, modalId) => {
                if(modalId == 'msgConfirm') _this.isModalShow = false;
            })
        },
        created() {
            if (
                !this.$route.params.hasOwnProperty("id") ||
                isNaN(this.$route.params.id)
            ) {
                return this.$router.push({
                    name: "permit-to-work-list"
                });
            }
            this.getItem()
        },
        methods: {
            /*-- Get Data --------*/
            getItem() {
                this.loadingDetail = true
                this.$store.dispatch( 'SafetyAppController/getPermitToWorkItem', this.$route.params.id)
                .then(response => {
                    // this.item = Object.assign(this.item, response)
                    this.loadingDetail = false
                })
                .catch(err => {
                    console.log(err)
                    this.loadingDetail = false
                })
            },
            async getCheckListGroupData(){
                this.loadingCheckListEntry = true;
                await this.$store
                    .dispatch("SafetyAppController/getSafetyCheckListGroupData", this.$route.params.id)
                    .then((result) => {
                        this.tableItems = result.items;
                        this.loadingCheckListEntry = false;
                        if(this.Item && this.Item.status == 'New') {
                            this.updateCheckListEntriesActive(this.tableItems);
                        }
                    })
                    .catch((err) => {
                        this.loadingCheckListEntry = false;
                });
            },
            reloadChecklist() {
                this.getCheckListGroupData();
            },
            async updateCheckListEntries(val){
                let params = val;
                let request = {
                    id: params.val.id,
                    value: params.val.input.value,
                    status: params.val.status,
                }
                if(params.val.hasOwnProperty('output')) request.output = params.val.output;
                if(params.val.hasOwnProperty('is_output_highlighted')) request.is_output_highlighted = params.val.is_output_highlighted;
                if(!params.from_status){
                    if(params.val.input.value){ request.status = params.val.status = 'Filled'; }
                    else{ request.status = params.val.status = 'Unfilled';}
                }

                let checkListEntryData = [request];
                if(this.checkListEntryUpdate.length > 0){
                    checkListEntryData = Object.assign([], this.checkListEntryUpdate);
                }
                let flag = false;
                if(checkListEntryData.length > 0){
                    for (let i = 0; i < checkListEntryData.length; i++) {
                        if (request && request.id == checkListEntryData[i].id) {
                            this.checkListEntryUpdate[i] = request;
                            flag = true;
                            break;
                        }
                    }
                    if(!flag){
                        this.checkListEntryUpdate.push(request);
                    }
                }
                this.isTyping = false;
            },
            selectChecklistEntry(entry) {
                this.modals.remark.checklistEntry = entry;
                this.modals.remark.open = true;
            },

            /*-- Store Data --------*/
            updateData() {
                if (this.timer_save) {
                    clearTimeout(this.timer_save);
                    this.timer_save = null;
                }
                this.timer_save = setTimeout(() => {
                    if(this.isTyping) {
                        this.isSave = true;
                        return;
                    }
                    if(this.isModalShow) return;
                    this.isSave = false;

                    // if (!this.$checkRole(this.$accessModule.job_list, "create")) {
                    //     return;
                    // }
                    var checkValidate = this.checkListEntryUpdate.filter(function(item) {
                        return (item.status === 'Filled' && !item.value);
                    });
                    if(checkValidate.length > 0){
                        return this.$alertNotification("Please enter checklist entries value when the status Filled", "danger");
                    }
                    this.loadingSave = true;
                    let request = {
                        array_data: JSON.stringify(this.checkListEntryUpdate),
                        job_id: this.Item.id
                    };
                    this.$store
                        .dispatch("SafetyAppController/updateCheckListJob", request)
                        .then(async (data) => {
                            // await this.getItem();
                            this.loadingSave = await false;
                            this.checkListEntryUpdate = [];
                            this.$alertNotification(this.$notificationV2("editing", "checklist"));
                        })
                        .catch((err) => {
                            this.$alertNotification("Can not update checklist!", "danger");
                        });
                }, 100);
            },
            reportJob() {
                if (this.timer_report) {
                    clearTimeout(this.timer_report);
                    this.timer_report = null;
                }
                this.timer_report = setTimeout(() => {
                    let nameFile = `${this.Item.job_number}.pdf`;
                    this.$store.dispatch("SafetyAppController/reportPermitToWorkItem", this.Item.id)
                    .then(response => {
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', nameFile);
                        document.body.appendChild(link);
                        link.click();
                    });
                }, 300);
            },
            activeJob(job) {
                if(!job || !job.id) return;
                this.getJobActive(job.id);
            },
            deleteFile(img) {
                if (img.moment) {
                    this.attachment.items = this.attachment.items.filter(
                        (item) => item.moment != img.moment
                    );
                    this.info.photos = this.info.photos.filter(
                        (item) => item.moment != img.moment
                    );
                } else {
                    this.attachment.items = this.attachment.items.filter(
                        (item) => item.id != img.id
                    );
                    this.$store.dispatch("SafetyAppController/deleteAttachments", {
                        ids: [img.id]
                    }).then(() => {
                        this.$emit("reloadItem");
                    })
                }
            },
            changeStatus() {
                if(!this.job_active && !this.job_active.id) {
                    return this.$alertNotification("No job active to change status", "warning");
                }

                let today = moment().format("YYYY-MM-DD");
                if(this.Item && this.Item.status != 'Approved' && this.Item.expiry_date && !moment(today).isAfter(moment(this.Item.expiry_date).format("YYYY-MM-DD"))) {
                   if(this.job_active.planned_date && new Date(this.job_active.planned_date).toDateString() !== new Date().toDateString()) {
                        return this.$alertNotification("Only can change status for job active with date is today", "warning");
                    } 
                }

                if(this.checkListEntryUpdate.length || this.isNotSave) {
                    let msg = "Please press the 'Save' button to save the data checklist before changing the status for this PTW."
                    if(this.isNotSave) {
                        msg = "Please press the 'Save' button in Stage 2 to save the data list before changing the status for this ptw."
                    }
                    return this.$alertNotification(msg, "warning");
                }

                this.$refs['basic-info'].editBacsicInfo()
            },
            saveWithPhotos() {
                let objeClone = {
                    data: {
                        type: this.Item.type,
                        project_id: this.Item.project_id,
                        location_id: this.Item.location_id,
                        location: this.Item.location,
                        started_date: moment(this.Item.started_date).format("YYYY-MM-DD HH:mm:ss"),
                        expiry_date: moment(this.Item.expiry_date).format("YYYY-MM-DD HH:mm:ss")
                    },
                    photos: this.attachment.items,
                    id: this.Item.id
                };

                this.$store.dispatch(`SafetyAppController/updatePermitToWorkItem`, objeClone)
                .then(async response => {
                    if(response.code && response.message) {
                        this.$alertNotification(response.message, "danger");
                        return;
                    }
                    this.getItem()
                })
                .catch(err => {
                    console.log(err)
                    this.isSave = false;
                    this.loadingSave = false;
                    if( err.response.data.error && err.response.data.error.message ) {
                        this.$alertNotification(err.response.data.error.message, "danger"); 
                    }
                })
            },
            getJobActive(id) {
                this.$store.dispatch( 'SafetyAppController/getPermitToWorkItemNotCommit', id)
                    .then(response => {
                        this.job_active = JSON.parse(JSON.stringify(response));
                    })
            },
            reloadItemDetail(id = null) {
                if(id && id != this.$route.params.id) {
                    this.getJobActive(id);
                    return
                }

                this.getItem();
            },
            updateCheckListEntriesActive(data) {
                this.checklistEntriesActive = data;
            },
            changeChecklistEntry(val) {
                this.isNotSave = false
                if(val) {
                    this.isNotSave = true
                }
            },
            async getUserLocation(type_id, type) {
                await this.$store.dispatch("JobController/getUserLocationJob", {
                    limit: 1,
                    showRelationship: '1',
                    filter: {
                        type: "safety_job",
                        type_id: type_id,
                        action: type
                    }
                })
                .then(response => {
                    this.modals.geo.items = response.items;
                });
            },
            async handleShowGeoFencing(id, type) {
                await this.getUserLocation(id, type)
                this.modals.geo.open = await true;
            }
        }
    }
</script>
<style lang="scss">
    .list-group-item {
        &.active {
            background-color: #F05600;
            border-color: #F05600;
        }
    }
</style>